import { container, heading, guide } from './empty.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Empty(props) {
  return /*#__PURE__*/jsxs("div", {
    ref: props.ref,
    className: container,
    children: [/*#__PURE__*/jsx("h3", {
      className: heading,
      children: "Der er ingen forl\xF8b, der matcher din filtrering"
    }), /*#__PURE__*/jsx("p", {
      className: guide,
      children: "Pr\xF8v eventuelt med en bredere filtrering"
    })]
  });
}

export { Empty };
//# sourceMappingURL=empty.js.map
